<template>
	<div class="row filter-nav align-center">
		<div class="columns column12">
			<span
				class="button filter-button"
				:class="{ active: filter === 'showAll' }"
				@click="$emit('change-filter', 'showAll')"
			>
				{{ $t('showAll') }}
			</span>
			<span
				v-for="item in items"
				:key="item"
				class="button filter-button"
				:class="{ active: filter === item }"
				@click="$emit('change-filter', item)"
			>
				{{ item }}
			</span>
		</div>
	</div>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});

defineEmits(['change-filter']);
</script>

<style lang="scss" scoped>
.filter-nav {
	margin: 0 auto 50px;
	display: flex;
	flex-wrap: wrap;

	span {
		margin-right: 10px;
		margin-bottom: 10px;
		transition: all 0.3s ease-in-out;
		cursor: pointer;
	}
}

@media (max-width: 800px) {
	.filter-nav {
		span.button {
			font-size: 11px;
			padding: 10px 12px 8px;
			letter-spacing: 1px;
			margin: 0 6px 5px 0;
		}
	}
}
</style>
